import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import "./home.css"
import ApiService from '../../services/apiService';
import gameImg from '../../Assets/images/Screenshot_5.png';
import { ClipLoader } from 'react-spinners';
import { FaStar } from 'react-icons/fa'; // install with `npm install react-icons`
import { toast } from 'react-toastify';
import GameHeader from '../header/header';
import Select from 'react-select';

const GamePage = () => {
    let navigate = useNavigate();
    const [loader, setLoader] = useState(false);
    const apiService = new ApiService();
    const [rating, setRating] = useState(0);        // current selected rating
    const [hover, setHover] = useState(null);
    const location = useLocation();
    const userData = location.state;
    const [rowData, setRowData] = useState(userData?.rowData);
    const [selectedOption, setSelectedOption] = useState(null);
    const [reviewText, setReviewText] = useState('');
    const commission = [
        { id: 1, commission: 1 },
        { id: 2, commission: 2 },
        { id: 3, commission: 4 },
        { id: 4, commission: 5 }
    ];
    const options = [
        { value: 'chocolate', label: 'I recommend for everyone to play this game you will love it 😍' },
        { value: 'strawberry', label: 'This game was truly amazing, very detailed in almost every aspect.' },
        { value: 'vanilla', label: 'This game is the best game of all time. I can say that the graphics still hold up.' },
        { value: 'vanilla', label: 'A great, classic game that started a great franchise. It was truly an amazing game to play and experience in the shoes of my favorite protagonist of all time' },
        { value: 'vanilla', label: 'Brilliant, just brilliant!' },
        { value: 'vanilla', label: 'I really gotta say. Dynamites come in small packages. And this is totally it😁.' },
        { value: 'vanilla', label: 'It’s got the great storyline, it’s got the quality resolution and very detail-oriented graphics Love the gameplay, story, graphics everything!' },
        { value: 'vanilla', label: 'Highly recommended. Have fun!' },
    ];
    const CalculateCommission = (price) => {
        const userLevel = userData?.userData?.memberLevel;
        const commissionObj = commission.find(x => x.id === userLevel);

        if (!commissionObj || !price) return 0;

        const amount = (price * commissionObj.commission) / 100;
        return amount.toFixed(2); // returns string with 2 decimal places
    };
    const calculateblnce = (price) => {
        const actualbalance = userData?.rowData?.actualbalance;
        const balance = userData?.userData?.balance;
        if (actualbalance) {
            const amount = (actualbalance - price);
            return amount.toFixed(2);
        } else {
            const amount = (balance - price);
            return amount.toFixed(2);
        }
    };
    const GenerateGame = async () => {
        setLoader(true)
        try {
            if ((userData?.rowData?.actualbalance || userData?.userData?.balance) < rowData?.price) {
                toast?.warning('Insufficient Balance Please go to recharge')
                setLoader(false)
                let userdata = userData?.userData
                debugger
                navigate(`/Recharge`, { state: { userdata, rowData } });
                return
            }
            const body = {
                userId: userData?.userData?.id,
                gameId: rowData?.id,
                gameRound: userData?.userData?.playedGames + 1,
            };
            const response = await apiService.post("PLAY_GAME", body);
            if (response?.status === 200 || response?.status === 201) {
                toast?.success("Game Successfully Optimized")
                startcarrier()
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error("Error:", error);
        }
    }
    const startcarrier = () => {
        navigate(`/Optimization`);
    }
    return (
        <div className="obtibg">
            <GameHeader />
            <div className='optimizeBox mt-lg-5'>
                <div className='responsive-img-container center'>
                    <img src={rowData?.thumb || gameImg} className='gameimg center' />
                </div>
            </div>
            <div className='py-3'>
                <h5 className='bodhead center'>{rowData?.name}</h5>
            </div>
            <div className='optimizeBox'>
                <div className='px-5 d-flex justify-content-between btn btn-lg btn-scondary w-100'>
                    <div className='boxtxt'>User Level</div>
                    <div className='boxtxt'>{userData?.userData?.memberLevel}</div>
                </div>

                <div className='d-flex justify-content-around mt-3'>
                    <div className='boxtxt'>Price (USDC)</div>
                    <div className='boxtxt'>Daily Profit (USDC)</div>
                    <div className='boxtxt'>Data Value (USDC)</div>
                </div>
                <div className='d-flex justify-content-around mt-1'>
                    <div className='boxtxt2'>{rowData?.price?.toFixed(2) || 0.00}</div>
                    <div className='boxtxt2'>{CalculateCommission(rowData?.price) || 0.00}</div>
                    <div className='boxtxt2'>{calculateblnce(rowData?.price) || 0.00}</div>
                </div>

                <div className='pt-3 center'>
                    {[1, 2, 3, 4, 5].map((star) => (
                        <FaStar
                            key={star}
                            size={24}
                            color={(hover || rating) >= star ? '#ffc107' : '#e4e5e9'}
                            onClick={() => setRating(star)}
                            onMouseEnter={() => setHover(star)}
                            onMouseLeave={() => setHover(null)}
                            style={{ cursor: 'pointer', transition: 'color 200ms' }}
                        />
                    ))}
                </div>
                <div className='pt-2 bodhead center'>Game Rating</div>
            </div>

            {/* Stylish Review Box */}
            <div className='optimizeBox p-4'>
                <div className='mb-3'>
                    <label htmlFor='reviewText' className='form-label text-white fw-bold'>Comment Good Reviews</label>
                    <Select
                        theme={(theme) => ({
                            ...theme,
                            borderRadius: 5,
                            padding: 9
                        })}
                        menuPortalTarget={document.body}
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            option: (provided, state) => ({
                                ...provided,
                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                color: state.isFocused ? '#000 ' : '#000',
                                ':hover': {
                                    backgroundColor: '#F5F5F5',
                                    color: '#000 ',
                                },
                            }),
                        }}
                        menuPlacement="auto"
                        menuShouldScrollIntoView={false}
                        className="p-0"
                        value={selectedOption}
                        onChange={setSelectedOption}
                        options={options}
                    />
                </div>
            </div>

            <div className='center p-3 '>
                {loader === true ?
                    <button class="btn btn-scondary center w-100 btn-lg " type="button">
                        <ClipLoader color='#fff' />
                    </button>
                    :
                    <button class="btn btn-scondary w-100 btn-lg " type="button" onClick={() => GenerateGame()}>
                        Optimize
                    </button>
                }
            </div>
        </div>
    );
};

export default GamePage;
